import { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { FHTextarea } from '../../../base';
import { useClientSupervisionEditable } from '../../../../hooks';
import { MINIMUM_REQUIRED_SENTENCE_LENGTH } from '../../../../constants';

import type { IClientSupervision } from '../../../../utils/types';
import type { ChangeEvent } from 'react';

interface OverallProgressTowardMasteryProps {
  clientSupervision: IClientSupervision | null;
  onUpdate: (data: IClientSupervision) => void;
}

function OverallProgressTowardMastery(props: OverallProgressTowardMasteryProps) {
  const { clientSupervision, onUpdate } = props;
  const [value, setValue] = useState<string>('');
  const [focusing, setFocusing] = useState<boolean>(false);
  const isEditable = useClientSupervisionEditable();

  useEffect(() => {
    setValue(clientSupervision?.overall_progress_toward_mastery || '');
  }, [clientSupervision]);

  const handleUpdate = () => {
    setFocusing(false);

    if (!clientSupervision) return;
    if (clientSupervision?.overall_progress_toward_mastery === value?.trim()) return;

    onUpdate({
      ...clientSupervision,
      overall_progress_toward_mastery: value?.trim(),
    });
  };

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
      <FHTextarea
        data-testid="clientSuperVisionNotes_overallProgressTextField"
        sx={{ borderRadius: '4px', boxShadow: 'none' }}
        fullWidth
        disabled={!isEditable}
        expandable={isEditable}
        placeholder="Description of client’s Overall progress toward mastery:"
        minLength={MINIMUM_REQUIRED_SENTENCE_LENGTH}
        value={value}
        onEdit={(e: ChangeEvent<HTMLTextAreaElement>) => {
          setValue(e.target.value);
        }}
        onFocus={() => setFocusing(true)}
        onBlur={handleUpdate}
        onCloseExpandDialog={handleUpdate}
        error={focusing && value.trim().length < MINIMUM_REQUIRED_SENTENCE_LENGTH}
        helperText={
          focusing && value?.trim().length < MINIMUM_REQUIRED_SENTENCE_LENGTH
            ? `Minimum ${MINIMUM_REQUIRED_SENTENCE_LENGTH} characters`
            : ''
        }
      />
    </Box>
  );
}

export default OverallProgressTowardMastery;
